export type MarketingNavMessageKey =
  | 'navAgents'
  | 'navHowItWorks'
  | 'navForBrands'
  | 'navForManufacturers'
  | 'navForAgencies'
  | 'navCompare'
  | 'navPricing'
  | 'navInsights'
  | 'navTerms'
  | 'navPrivacy';

const CANONICAL_NAV_BY_HREF: Record<
  string,
  { englishLabel: string; messageKey: MarketingNavMessageKey }
> = {
  '/agents': { englishLabel: 'Agents', messageKey: 'navAgents' },
  '/how-it-works': {
    englishLabel: 'How It Works',
    messageKey: 'navHowItWorks',
  },
  '/for-brands': { englishLabel: 'For Brands', messageKey: 'navForBrands' },
  '/for-manufacturers': {
    englishLabel: 'For Manufacturers',
    messageKey: 'navForManufacturers',
  },
  '/for-agencies': {
    englishLabel: 'For Agencies',
    messageKey: 'navForAgencies',
  },
  '/vs-alternatives': { englishLabel: 'Compare', messageKey: 'navCompare' },
  '/pricing': { englishLabel: 'Pricing', messageKey: 'navPricing' },
  '/insights': { englishLabel: 'Insights', messageKey: 'navInsights' },
  '/terms': { englishLabel: 'Terms', messageKey: 'navTerms' },
  '/privacy': { englishLabel: 'Privacy', messageKey: 'navPrivacy' },
};

export function localizeMarketingNavLabel({
  href,
  label,
  translate,
}: {
  href: string;
  label: string;
  translate: (key: MarketingNavMessageKey) => string;
}): string {
  const canonical = CANONICAL_NAV_BY_HREF[href];
  if (!canonical || canonical.englishLabel !== label) {
    return label;
  }

  return translate(canonical.messageKey);
}
